import { ComponentProps, ReactNode, FC } from 'react'
import * as styles from 'styles/atoms/preloaders/LoadingOverlay.css'
import cn from 'classnames'
import Spinner from 'components/features/pfm/Spinner/Spinner'

type LoadingOverlayProps = {
  isTransparent?: boolean
  className?: string
  children?: ReactNode
  size?: ComponentProps<typeof Spinner>['size']
}

export const LoadingOverlay: FC<LoadingOverlayProps> = (props) => {
  const { isTransparent, className: outerClassName, children, size } = props
  const className = cn(styles.loadingOverlay, {
    [styles.transparent]: isTransparent,
    [styles.asColumn]: Boolean(children),
  }, outerClassName)

  return (
    <div className={ className }>
      <Spinner size={ size } />
      { children }
    </div>
  )
}

export default LoadingOverlay
